import {SelectFieldValueType, SelectFieldOptionsItemType} from "../types";

export default function isActiveOption(value: SelectFieldValueType, option: SelectFieldOptionsItemType): boolean {
    if (Array.isArray(value)) {
        return value.find(item => item === option.value)
    }
    return value === option.value
}